import React from 'react';
import classnames from 'classnames';
import Input from '../Input';

const TextFieldGroup = ({ field, placeholder, value, error, type, onChange, checkUserExits, classes }) => {
  return (
    <div className={classnames('form-group', { 'has-error': error })}>
      <Input
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={checkUserExits}
        type={type}
        name={field}
        id={field}
        className={classes}
      />
      {error && <span className="help-block">{error}</span>}
    </div>
  );
};


TextFieldGroup.propTypes = {
  field: React.PropTypes.string.isRequired,
  placeholder: React.PropTypes.string.isRequired,
  value: React.PropTypes.string.isRequired,
  error: React.PropTypes.string,
  type: React.PropTypes.string.isRequired,
  onChange: React.PropTypes.func,
  checkUserExits: React.PropTypes.func,
  classes: React.PropTypes.string,
};

TextFieldGroup.defaultProps = {
  type: 'text',
};

export default TextFieldGroup;



// WEBPACK FOOTER //
// ./src/components/common/TextFieldGroup/index.js